
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { toast } from "@/components/ui/use-toast";
import { useAuth } from "@/contexts/AuthContext";

const creditPackages = [
  { credits: 50, price: 5, description: "Βασικό πακέτο" },
  { credits: 150, price: 10, description: "Δημοφιλές πακέτο" },
  { credits: 500, price: 30, description: "Επαγγελματικό πακέτο" }
];

export function CreditsSection() {
  const { userCredits, setUserCredits } = useAuth();

  const handlePurchase = (credits: number, price: number) => {
    // Ενημερώνουμε τα credits του χρήστη
    setUserCredits(userCredits + credits);
    
    toast({
      title: "Αγορά Credits",
      description: `Αγοράσατε ${credits} credits για ${price}€. Νέο υπόλοιπο: ${userCredits + credits} credits.`,
    });
    
    // Αποστολή email ειδοποίησης για την αγορά
    sendPurchaseNotification(credits, price);
  };
  
  // Αποστολή ειδοποίησης email
  const sendPurchaseNotification = async (credits: number, price: number) => {
    try {
      // Χρησιμοποιούμε το EmailJS ή παρόμοια υπηρεσία για αποστολή email από το frontend
      // Εναλλακτικά, θα μπορούσαμε να χρησιμοποιήσουμε webhooks (π.χ. Zapier) ή ένα backend API
      
      // Για λόγους επίδειξης, εμφανίζουμε μήνυμα στην κονσόλα
      console.log(`Αποστολή ειδοποίησης στο nektarios@web-star.gr για αγορά ${credits} credits αξίας ${price}€`);
      
      // Δημιουργία του σώματος του email με τα στοιχεία της αγοράς
      const emailBody = {
        to: "nektarios@web-star.gr",
        subject: "Νέα αγορά credits",
        message: `
          Έγινε νέα αγορά credits!
          
          Πακέτο: ${credits} credits
          Τιμή: ${price}€
          Ημερομηνία: ${new Date().toLocaleString('el-GR')}
        `
      };
      
      // Εδώ θα μπορούσαμε να κάνουμε το API call σε έναν email service
      // fetch('https://api.emailjs.com/api/v1.0/email/send', {
      //   method: 'POST',
      //   headers: { 'Content-Type': 'application/json' },
      //   body: JSON.stringify(emailBody)
      // });
      
      // Για τώρα απλά εμφανίζουμε στην κονσόλα τα στοιχεία
      console.log("Email notification details:", emailBody);
      
    } catch (error) {
      console.error("Σφάλμα κατά την αποστολή ειδοποίησης:", error);
      toast({
        title: "Σφάλμα",
        description: "Υπήρξε ένα πρόβλημα με την αποστολή της ειδοποίησης αγοράς.",
        variant: "destructive"
      });
    }
  };

  return (
    <div className="w-full max-w-6xl mx-auto p-4">
      <h2 className="text-2xl font-bold text-center mb-6">Αγορά Credits</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {creditPackages.map((pkg, index) => (
          <Card key={index} className="p-6 flex flex-col items-center">
            <h3 className="text-xl font-semibold mb-2">{pkg.description}</h3>
            <p className="text-3xl font-bold text-primary mb-2">{pkg.credits} Credits</p>
            <p className="text-2xl mb-4">{pkg.price}€</p>
            <Button 
              onClick={() => handlePurchase(pkg.credits, pkg.price)}
              className="w-full"
            >
              Αγορά
            </Button>
          </Card>
        ))}
      </div>
      
      <div className="mt-8 p-4 bg-muted/30 rounded-lg text-sm text-center">
        <p className="max-w-4xl mx-auto">
          Τα παραπάνω πακέτα χρήσης της ιστοσελίδας ισχύουν μόνο στην περίπτωση που υπάρχει ενεργό συμβόλαιο 
          σε εμπορική εφαρμογή στις εταιρίες TESAE Group ή EpsilonNet, ισχύουν για ένα(1) έτος και 
          η ανανέωση γίνεται με την ανανέωση ετήσιου συμβολαίου.
        </p>
      </div>
    </div>
  );
}
